import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../styles/EventDetail.module.css"; // CSS module for detail page styles
import { Calendar, MapPin, Clock, Users, DollarSign, Target, Briefcase, Handshake } from "lucide-react";
import foundersFridayImage from '../assets/event.png'; // Placeholder for event image

const EventDetailFoundersFriday = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Updated event data
  const eventData = {
    title: "Founders’ Friday: Where Dreams Ignite",
    recap:
      "Last week's Founders’ Friday was a night to remember! The room buzzed with energy as founders took the stage to share their bold visions, sparking conversations that could shape tomorrow’s breakthroughs. From powerful startup pitches to hands-on product demos, the event was a melting pot of innovation and connection. Missed it? Don’t worry—this is just the beginning!",
    objective:
      "To amplify startup visibility, foster knowledge exchange, and spark collaborations among founders, innovators, and industry leaders from diverse backgrounds.",
    description:
      "Founders’ Friday is a monthly celebration of innovation where selected startup founders light up the stage with their entrepreneurial journeys. Expect captivating pitches, live product demos, and interactive sessions that let you experience groundbreaking ideas firsthand. Connect with a vibrant community of dreamers and doers, and turn your ideas into impact. Brought to you by Arifpay & WeVenture, this is where the future of business begins!",
    targetAudience:
      "Founders, aspiring entrepreneurs, investors (angels, VCs), grant organizations, innovation hubs, financial industry leaders, and business owners ready to change the game.",
    keyActivities: [
      "10 Minutes – Welcome messages from partners and sponsors",
      "15 Minutes – Inspiring pitch by a startup cofounder or CEO, covering the problem, solution, target market, traction, and funding journey",
      "20 Minutes – Live demo and hands-on trial of the startup’s product or service",
      "30 Minutes – Break with pizza, drinks, and networking",
      "15 Minutes – Q&A and lively discussion between presenters and attendees",
      "30 Minutes – Closing with more pizza, drinks, and networking",
    ],
    nextEventDetails: "September 19, 2025, 5:00 PM, WeVentureHub HQ",
    expectedAttendees: "120+",
    expectedOutcomes: [
      "Increased visibility and client acquisition for presenting startups",
      "Partnership and collaboration opportunities with Arifpay, WeVenture, and other ecosystem players",
      "Brand exposure for partners and sponsors",
      "Networking with key players in the startup and business ecosystem to forge meaningful connections",
    ],
    partners: ["Arifpay", "WeVenture", "Awash Bank", "Shega Media"],
  };

  return (
    <div>
      <Header />
      <div className={styles.detailContainer}>
        <div className={styles.detailHeader}>
          <img
            src={foundersFridayImage}
            alt={eventData.title}
            className={styles.detailHeroImage}
          />
          <div className={styles.detailHeaderContent}>
            <h1>{eventData.title}</h1>
            <p className={styles.recap}>{eventData.recap}</p>
            <p className={styles.objective}>{eventData.objective}</p>
            <div className={styles.eventInfoGrid}>
              <div className={styles.eventInfoItem}>
                <Calendar size={20} />
                <span>{eventData.nextEventDetails.split(',')[0]}</span>
              </div>
              <div className={styles.eventInfoItem}>
                <Clock size={20} />
                <span>{eventData.nextEventDetails.split(',')[1]}</span>
              </div>
              <div className={styles.eventInfoItem}>
                <MapPin size={20} />
                <span>{eventData.nextEventDetails.split(',')[2]}</span>
              </div>
              <div className={styles.eventInfoItem}>
                <Users size={20} />
                <span>Expected Attendees: {eventData.expectedAttendees}</span>
              </div>
            </div>
            <div className={styles.callToAction}>
              <p>Join us at the next Founders’ Friday! Bring your vision, pitch your idea, and connect with a community that’s changing the game.</p>
              <a href="https://x.ai/founders-friday" className={styles.registerButton}>Register Now</a>
            </div>
          </div>
        </div>

        <div className={styles.detailContent}>
          <section className={styles.section}>
            <h2>What It’s All About</h2>
            <p>{eventData.description}</p>
          </section>

          <section className={styles.section}>
            <h2>
              <Target size={20} /> Who Should Attend
            </h2>
            <p>{eventData.targetAudience}</p>
          </section>

          <section className={styles.section}>
            <h2>
              <Briefcase size={20} /> What to Expect
            </h2>
            <ul>
              {eventData.keyActivities.map((activity, index) => (
                <li key={index}>{activity}</li>
              ))}
            </ul>
          </section>

          <section className={styles.section}>
            <h2>
              <DollarSign size={20} /> Why It Matters
            </h2>
            <ul>
              {eventData.expectedOutcomes.map((outcome, index) => (
                <li key={index}>{outcome}</li>
              ))}
            </ul>
          </section>

          <section className={styles.section}>
            <h2>
              <Handshake size={20} /> Our Partners
            </h2>
            <div className={styles.partnersList}>
              {eventData.partners.map((partner, index) => (
                <span key={index} className={styles.partnerBadge}>{partner}</span>
              ))}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventDetailFoundersFriday;